<template>
  <div class="item" v-if="photos && photos.length > 0">
    <label>{{'Attached Photos'|translate}}</label>
    <div class="gallery" >
      <a class="wrap"  v-for="(photo, photoIndex) in photos" :key="photoIndex" @click="index = photoIndex" >
        <img class="thumb" :src="photo.url_thumb"  />
      </a>
    </div>
    <gallery v-if="photos" :images="images" :index="index" @close="index = null"></gallery>
  </div>
</template>
<script>
import gallery from 'vue-gallery'
export default {
  name: 'historyPhoto',
  props: ['item'],
  components: {
    gallery
  },
  data () {
    return {
      index: null
    }
  },
  computed: {
    images () {
      if (this.photos) {
        return this.photos.map(item => { return item.url_medium })
      } else {
        return []
      }
    },
    photos () {
      return this.item ? this.item.images : []
    }
  },
  created () {
    // https://api.viectam.com/api/job-image-upload/?job=48
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/ListHistoryPhoto.vue